<template>
    <el-row :gutter="20" class="main_block">
        <div class="mianContent">
            <span class="back" @click="$router.go(-1)"><i class="el-icon-back"></i>&nbsp;&nbsp;&nbsp;&nbsp;返回</span>
            <div class="content">
                <h4>认证方式</h4>
                <div class="sec_wrap">
                    <div class="section" @click.stop="goOnline">
                        <div class="typeNum">方式一</div>
                        <div class="typeName">
                            法定代表人在线意愿认证（推荐）
                        </div>
                        <div class="des">
                            认证方便，无需对公打款，需法定代表人本人操作
                        </div>
                        <div class="arrow">
                            <span>开始认证</span>
                            <img src="@/assets/images/realName/arrow1.png" alt="">
                        </div>
                        <a class="guide" @click.stop="goTsa">认证流程指引</a>
                    </div>
                    <div class="section two" @click="goOffline">
                        <div class="typeNum">方式二</div>
                        <div class="typeName">
                            对公账户打款
                        </div>
                        <div class="des">
                            适合法定代表人不便在线签署的机构
                        </div>
                        <div class="arrow">
                            <span>开始认证</span>
                            <img src="@/assets/images/realName/arrow2.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-row>
</template>

<script>
import { identification } from "@http/user_center/userInfo";
export default {
    data() {
        return {
            status: 0,
        };
    },

    components: {},

    computed: {},

    created() {
        this.init()
    },

    mounted() {},

    methods: {
        async init(){
            let {authenticationStatus}=await identification();
            this.status=authenticationStatus;
        },
        goOffline(){
            this.$TsaWebTrace.post({
                data: {
                    "eventId": 35032,
                },
            });
            if(this.status==6){
                this.$router.push({
                    path:'/userCenter/realName/enterpriseResult'
                })
            }else if(this.status==10 || this.status==7){
                this.$msg('您的认证已完成','success');
            }else if(this.status==4 || this.status==8){
                this.$router.push({
                    path:'/userCenter/realName/enterpriseApply'
                })
            }else if(this.status==9){
                this.$router.push({
                    path:'/userCenter/realName/enterpriseSign'
                })
            }else{
                this.$router.replace({
                    path:'/userCenter/AuthenticationName'
                })
            }
        },
        goOnline(){
            this.$TsaWebTrace.post({
                data: {
                    "eventId": 35019,
                },
            });
            if(this.status==6){
                this.$router.push({
                    path:'/userCenter/realName/enterpriseResult'
                })
            }else if(this.status==10 || this.status==7){
                this.$msg('您的认证已完成','success');
            }else if(this.status==4 || this.status==9 || this.status==8){
                this.$router.push({
                    path:'/userCenter/realName/enterpriseSign'
                })
            }else{
                this.$router.replace({
                    path:'/userCenter/AuthenticationName'
                })
            }
        },
        goTsa(){
            window.open('https://www.tsa.cn/guide/detail/1048');
        }
        
    },
};
</script>
<style lang="less" scoped>
.mianContent{
    position: relative;
    .back{
        position:absolute;
        right: 30px;
        top:-30px;
        font-size: 14px;
        cursor: pointer;
        &:hover{
            color:#10A0E9
        }
    }
}
.content{
    width: 1250px;
    margin:0 auto;
    h4{
        font-size: 20px;
        margin:36px 0 22px;
    }
    .sec_wrap{
        display: flex;
        justify-content: space-between;
        .guide{
            float:right;
            margin-top:10px;
            color:#10A0E9;
        }
    }
    .section{
        width: 598px;
        height: 230px;
        background:#FFF9EB;
        cursor: pointer;
        .typeNum{
            font-size: 14px;
            width: 64px;
            height: 29px;
            line-height: 29px;
            background:#EAAC1C;
            color: #fff;
            text-align: center;
        }
        .typeName{
            font-size: 20px;
            color: #EAAC1C;
            padding:33px 0 33px 26px;
        }
        .des{
            color: #797261;
            font-size: 18px;
            padding:0 0 15px 26px;
        }
        .arrow{
            padding-right: 30px;
            padding-bottom: 45px;
            display: flex;
            align-items: center;
            color: #EAAC1C;
            justify-content: flex-end;
            font-size: 18px;
            img{
                width: 27px;
                height: 27px;
                margin-left: 20px;
            }
        }
    }
    .two{
        background:#E8F7FF;
        .typeNum{
            background:#10A0E9;
        }
        .typeName{
            color: #10A0E9;
        }
        .des{
            color: #6B9AB3;
        }
        .arrow{
            color: #10A0E9;
        }
    }
    .three{
        background:#f5f5f5;
        .typeNum{
            background:#ccc;
        }
        .typeName{
            color: #999;
        }
        .des{
            color: #999;
        }
        .arrow{
            color: #333;
        }
    }
}

@media screen and (max-width:1500px) {
    .content{
        width: 100%;
        .section{
            width: 508px;
            height: 220px;
        }
    }
    
}
</style>
